<template>
  <div v-if="dataIsLoad" class="product-info">
    <div>
      <div class="tag-label">
        <span v-for="label in itemDatas.Labels" :key="label.Description">
          {{ label.Description }}
        </span>
        <span v-if="allSpecPreOrder">PRE-ORDER</span>
        <span v-if="!allSpecPreOrder && selectedSpec !== null && selectedSpec.PreOrder">
          PRE-ORDER
        </span>
      </div>
      <div class="product-fav">
        <div>
          <a :href="itemDatas.Brand?.Url" class="brand-name">
            {{ itemDatas.Brand?.Name }}
          </a>
          <h1 class="product-name">{{ itemDatas.Name }}</h1>
        </div>
        <div>
          <WishBtn
            :wish-active="selectedData.IsFavorite"
            :custommarket-id="shopContentStore.favCustomMarketID"
            :product-name="itemDatas.Name"
            :product-sell-price="itemDatas.SellPrice"
            :selected-color="selectedData.Name"
            :selected-spec="selectedSpec.Name"
          />
          <ShareBtn :market-id="itemDatas.MarketID" />
        </div>
      </div>
      <h3 class="product-subtitle">{{ itemDatas.SubTitle }}</h3>
      <h3 class="product-price">
        <div>
          <span
            v-if="itemDatas.EventPrice > 0 || itemDatas.SellPrice !== itemDatas.OriginPrice"
            class="origin-price"
          >
            NT.{{ itemDatas.OriginPrice }}
          </span>
          <span class="sell-price"> NT.{{ mapSellPrice }} </span>
        </div>

        <div v-if="ShowBranchStock" class="shop-store-btn" @click="isOpenStockDialog = true">
          <img src="https://static.tpx.tw/sff/urliving/static/img/url-logo.png" alt="" />
          門市庫存
        </div>
      </h3>
      <div>
        <p v-for="(note, noteIndex) in itemDatas.CouponNotes" :key="noteIndex" class="no-11">
          {{ note }}
        </p>
      </div>
      <div v-if="mapEvents" class="product-event">
        <div v-if="itemDatas.Limit !== 0" class="py-1">此商品限購 {{ itemDatas.Limit }} 件</div>
        <div v-for="(event, index) in itemDatas.Events" :key="index" class="py-1">
          <a :href="'/campaign/' + event.ID">{{ event.Name }}</a>
        </div>
        <div v-for="(giftevent, index) in itemDatas.GiftEvents" :key="index" class="py-1">
          <a :href="'/campaign/gift/' + giftevent.ID">{{ giftevent.Name }}</a>
        </div>
      </div>
    </div>
    <div>
      <div class="item-pick">
        <div class="select-block">
          <div class="select-style" :class="{ spread: sizeBtn }">
            <a class="select-btn" @click.prevent.stop="openSelector">{{ selectedData.Name }} </a>
            <ul class="select-opts" :class="{ isopen: selectIsOpen }">
              <li
                v-for="color in itemDatas.Colors"
                :key="color.ID"
                @click.prevent="changeImg(color.ID)"
              >
                {{ color.Name }}
              </li>
            </ul>
          </div>
          <Selector
            v-if="!sizeBtn"
            :options="selectedData.Specs"
            :selected="selectedSpec"
            @cb="selectSpec"
          />
        </div>
        <div class="count-selector">
          <Quantity
            :counter="counter"
            :reduce-count="() => reduceCount()"
            :add-count="
              () =>
                addCount({
                  maxCount: selectedSpec.Stock,
                  limit: itemDatas.Limit,
                })
            "
          />
        </div>
        <a
          :class="btnStyleGenerate"
          class="btn btn-primary w-100 btn-add2cart"
          @click.prevent="clickToCart"
        >
          {{ btnDescriptionGenerate }}
        </a>
      </div>
      <div v-if="allSpecPreOrder" class="product-arrival">
        {{ itemDatas.ArrivalExplanation }}
      </div>
      <div v-if="!allSpecPreOrder && selectedSpec !== null && selectedSpec.PreOrder">
        {{ itemDatas.ArrivalExplanation }}
      </div>
      <div class="product-ad">
        <a v-for="(ad, index) in activeAdEvents" :key="index" :href="ad.adHref" class="d-block">
          <img :src="ad.adImg" class="img-fluid" />
        </a>
      </div>
    </div>
    <div ref="shopTop" class="shop-top">
      <a
        :class="itemDatas.IsPreShow ? 'btn-secondary disabled' : ''"
        class="open-dialog"
        data-dialog="#dialog-market"
        @click.prevent="showMobileCartDialog"
      >
        <i class="icon-shop-cart" />
      </a>
      <a href="#">
        <i class="icon-shop-top" />
      </a>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import { storeToRefs } from 'pinia';
import useShopContentStore from '@global/stores/useShopContentStore';
import Selector from '@components/Select.vue';
import Quantity from '@components/Quantity.vue';
import WishBtn from '@components/WishBtn.vue';
import ShareBtn from '@components/ShareBtn.vue';
import $ from 'jquery';
import useMsg from '@global/composable/useMessage';
import useAlert from '@global/composable/useAlert';

const { messageBox } = useMsg();
const { alertDialog } = useAlert();

const isBindEvent = ref(false);
const ShowBranchStock = ref(window.ShowBranchStock);
const category = window.ItemCategories[0];

const shopContentStore = useShopContentStore();
const {
  selectedData,
  itemDatas,
  dataIsLoad,
  selectedSpec,
  counter,
  selectIsOpen,
  allSpecPreOrder,
  btnStyleGenerate,
  btnDescriptionGenerate,
  isOpenStockDialog,
} = storeToRefs(shopContentStore);

const {
  addCount,
  reduceCount,
  openSelector,
  showMobileCartDialog,
  addToCart,
  selectSpec,
  changeImg,
} = shopContentStore;

const sizeBtn = computed(() => {
  return (
    // 非服飾類 & 單一顏色尺寸 & 尺寸為F，須隱藏尺寸下拉選單
    category !== '服飾' &&
    selectedData.value.Specs?.length === 1 &&
    selectedData.value.Specs[0]?.Name === 'F' &&
    selectedData.value.Specs[0]?.Stock > 0
  );
});

const mapEvents = computed(() => {
  return (
    itemDatas.value.Events?.length !== 0 ||
    itemDatas.value.GiftEvents?.length !== 0 ||
    itemDatas.value.Limit !== 0
  );
});

const mapSellPrice = computed(() => {
  return itemDatas.value.EventPrice > 0 && itemDatas.value.EventPrice < itemDatas.value.SellPrice
    ? itemDatas.value.EventPrice
    : itemDatas.value.SellPrice;
});

const shopTop = ref(null);

watch(dataIsLoad, (isLoad) => {
  if (isLoad && !isBindEvent.value) {
    $(window).click(() => {
      if (selectIsOpen.value) {
        openSelector();
      }
    });

    $(window).scroll(() => {
      if (shopTop.value) {
        if ($(window).scrollTop() > 500) {
          shopTop.value.style.opacity = 1;
          shopTop.value.style.visibility = 'visible';

          shopTop.value.click((e) => {
            e.preventDefault();
            $('html,body').animate({ scrollTop: 0 }, 300);
            return false;
          });
        } else {
          shopTop.value.style.opacity = 0;
          shopTop.value.style.visibility = 'hidden';
        }
      }
    });

    isBindEvent.value = true;
  }
});

async function clickToCart() {
  try {
    const resolve = await addToCart();
    if (resolve === undefined) return;
    const { code } = resolve;

    switch (code) {
      case 200:
        messageBox.cart('加入購物車');
        break;
      case 205:
        alertDialog.alert('商品已售完', () => {
          window.location.reload();
        });
        break;
      default:
        break;
    }
  } catch (error) {
    console.log(error);
  }
}

const newDate = new Date().getTime();
const adEvents = [
  {
    StartDate: new Date(2024, 5, 18, 10, 0, 0),
    EndDate: new Date(2024, 5, 23, 23, 59, 59),
    AdHref: 'https://www.urliving.com/en-us/news/144',
    AdImg: 'https://static.tpx.tw/sff/urliving/static/img/ad/20240618-1.jpg',
  },
  {
    StartDate: new Date(2024, 5, 18, 10, 0, 0),
    EndDate: new Date(2024, 5, 23, 23, 59, 59),
    AdHref: 'https://www.urliving.com/login',
    AdImg: 'https://static.tpx.tw/sff/urliving/static/img/ad/20240618-2.jpg?v1',
  },
  {
    StartDate: new Date(2024, 5, 24, 0, 0, 0),
    EndDate: '',
    AdHref: 'https://www.urliving.com/login',
    AdImg: 'https://static.tpx.tw/sff/urliving/static/img/ur-ad-01.jpg',
  },
  {
    StartDate: new Date(2024, 5, 24, 0, 0, 0),
    EndDate: '',
    AdHref: 'https://5.urliving.com/',
    AdImg: 'https://static.tpx.tw/sff/urliving/static/img/ur-ad-02.jpg',
  },
];

const activeAdEvents = [];

adEvents.forEach((event) => {
  if (
    event.EndDate &&
    newDate >= event.StartDate.getTime() &&
    newDate <= event.EndDate?.getTime()
  ) {
    activeAdEvents.push({ adHref: event.AdHref, adImg: event.AdImg });
  } else if (newDate >= event.StartDate.getTime() && event.EndDate === '') {
    activeAdEvents.push({ adHref: event.AdHref, adImg: event.AdImg });
  }
});
</script>
